module.exports = __webpack_public_path__ + "c545579096d572ffd373f75333e980d8.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-Regular.eot
 ** module id = 358
 ** module chunks = 9
 **/